export default __webpack_public_path__ + "static/media/dinnerHealthgenom.deb8eab0.svg";